import { render } from "./Head.vue?vue&type=template&id=5f1c74b9&scoped=true"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"

import "./Head.vue?vue&type=style&index=0&id=5f1c74b9&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-云南农业大学-前台页面/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1c74b9"]])

export default __exports__